import toggle from './toggle';
import compose from './compose';

function productGridItemQuickAddMenu() {
  return compose(toggle(), {
    controller: null,

    init() {
      this.$watch('isOpen', (isOpen) => {
        if (isOpen) {
          this.listen();
        } else {
          this.unlisten();
        }
      });
    },

    // Only listen for events when the menu is open in order to reduce unnecessary event listeners
    listen() {
      this.controller = new AbortController();

      // Close on mouse leave
      this.$el.addEventListener(
        'mouseleave',
        () => {
          this.close();
        },
        {signal: this.controller.signal}
      );

      // Close on click outside
      document.addEventListener(
        'click',
        (e) => {
          if (this.$el.contains(e.target)) return;
          // Additional check for special implementations like x-collapse
          // where the element doesn't have display: none
          if (this.$el._x_isShown === false) return;
          this.close();
        },
        {signal: this.controller.signal}
      );

      // Close on focus outside
      document.addEventListener(
        'focusin',
        (e) => {
          if (this.$el.contains(e.target)) return;
          this.close();
        },
        {signal: this.controller.signal}
      );

      // Close when esc pressed
      document.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Escape') {
            this.close();
          }
        },
        {signal: this.controller.signal}
      );
    },

    unlisten() {
      // Remove all listeners
      this.controller.abort();
      this.controller = null;
    },
  });
}

export default productGridItemQuickAddMenu;
